import { $qs, $qsa } from '../../utils/QuerySelector';
import gsap from 'gsap';
import Swiper, { Navigation, Pagination, Scrollbar, Autoplay, FreeMode } from 'swiper';
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

function homepage() {
  

    
    
    console.log('newhome')
    var mq = window.matchMedia('(min-width: 1024px)')

    gsap.to([ "[data-target='home_copy'] *"], {autoAlpha:1, duration:1, delay:1.5 })
    gsap.to(["[data-target='video_home']"], {autoAlpha:1, duration:1,delay:.5 });
    gsap.from("[data-target='home_strip']", {height: "100%", stagger:.2, duration:1, delay:1})


    // let homeslidingimages = gsap.timeline({
    //   scrollTrigger: {
    //       trigger: "[data-element='home_banner']",
    //       pin: true,
    //       scrub: 2,
    //       start: "top top",
    //       //pinSpacing: false
    //     }
    //   });
      
     
    //   homeslidingimages.to("[data-target='home_strip']", {
    //     scaleY: 0, 
    //     stagger: {
    //       amount: 0.2,  
    //       from: "end", 
    //     },
    //     ease: "power2.out"
    //   }, "start")
    //   .to("[data-target='home_copy']", {
    //     autoAlpha: 0, 
    //     ease: "power2.out"
    //   }, "start")
      
     
    

    if (mq.matches) {
    let navigationpin =  gsap.to("[data-js='navigation']",  {
      autoAlpha:1,
      scrollTrigger: {
        trigger: "[data-element='home_banner']",
        pin: "[data-js='navigation']",
        scrub: 2,
        start: "top top",
        //pinSpacing:false
      }
    });
    }


    

    

   

    let st = ScrollTrigger.create({
      trigger: "[data-element='home_slide_wrap']",
      pin: "[data-element='home_slide_img_wrap']",
      start: "top top",
      end: "bottom bottom"
    });

    const imgtotal = $( "[data-element='home_slide_img']").length;
    const databg1 =  $( "[data-element='home_slide_bg'][data-count='1'" ).data('bg');
    gsap.set($( "[data-element='home_slide_bg']" ).parent().parent(), {className: "duration-300 bg-"+databg1+""})
    $( "[data-element='home_slide_bg']" ).each(function( index ) {
      const slide = $(this);
      const slideparent = $(this).parent().parent();
      const bg = $(this).data('bg');
      const imgcount = slide.attr('data-count');
      const img = $( "[data-element='home_slide_img'][data-count='" + imgcount + "']" );
      const widthmenu = $( "[data-element='home_slide_menu'][data-count='" + imgcount + "']" ).width();
      const leftmenu = $( "[data-element='home_slide_menu'][data-count='" + imgcount + "']" ).offset().left - $( "[data-element='home_slide_menu_wrap']" ).offset().left + 8
      
      const bordercolor =  $( "[data-element='home_slide_menu'][data-count='" + imgcount + "']" ).data('border');
      
      gsap.to(slideparent, {
        scrollTrigger: {
          trigger: slide,
          start: "center bottom", 
          end:"+="+""+$(this).height(),
          toggleActions: "play none none reverse",
          onEnter: function(){ 
            gsap.set(slideparent, {className: "duration-300 bg-"+bg+"",})
            gsap.set($("[data-element='home_slide_menu_line']"), {className: "h-[5px] absolute bottom-0 duration-300 bg-"+bordercolor+"",})
            
            $("[data-element='home_slide_menu_line']").css('width', widthmenu )
            $("[data-element='home_slide_menu_line']").css('left', (leftmenu) )
           
           },
           onEnterBack: function(){ 
            gsap.set(slideparent, {className: "duration-300 bg-"+bg+"",})
            gsap.set($("[data-element='home_slide_menu_line']"), {className: "h-[5px] absolute bottom-0 duration-300 bg-"+bordercolor+"",})
            $("[data-element='home_slide_menu_line']").css('width', widthmenu )
            $("[data-element='home_slide_menu_line']").css('left', (leftmenu) )
           },
        }
        
        
      });
      if(imgcount < imgtotal) {
        gsap.to(img, {
          scrollTrigger: {
            trigger: slide,
            start: "bottom 60%",
            end:300,
            toggleActions: "play none none reverse",
          },
          y:"-100vh"
        });
      }
      

      
    });

   

    const scaleimgh =  $(window).height() / $("[data-element='big_image_gallery']").height();
    const scaleimgw =  $(window).width() / $("[data-element='big_image_gallery']").width();
    const scaleimg = Math.max(scaleimgh,scaleimgw)
    $("[data-element='home_img_gallery']").css('margin-top',$("[data-element='big_image_wrap']").height() * (scaleimg / 1.7) )
    let bigimgfunction =  gsap.from("[data-element='big_image_wrap']",  {
      scale:scaleimg,
      scrollTrigger: {
        trigger: "[data-element='big_image_wrap']",
        pin:"[data-element='big_image_wrap_pin']",
        start: "50% 50%",
        pinSpacing:false,
        scrub:true,
      }
    });
    gsap.set($("[data-element='big_image_wrap'] picture:nth-child(2)"), {y:"-=100px",x:"+=50px", scale:.7});
    gsap.set($("[data-element='big_image_wrap'] picture:nth-child(3)"), {x:"-=200px", scale:.7});
    gsap.set($("[data-element='big_image_wrap'] picture:nth-child(4)"), {y:"-=50px",x:"+=200px", scale:.7});
    gsap.set($("[data-element='big_image_wrap'] picture:nth-child(5)"), {y:"+=200px",x:"+=200px", scale:.7});
    let bigimgfunction2 =  gsap.to("[data-element='big_image_wrap'] picture",  {
      y:"0",
      x:"0",
      scale:1,
      scrollTrigger: {
        trigger: "[data-element='big_image_wrap']",
        start: "50% 50%",
        scrub:true,
      }
    });

   
    
    gsap.set("[data-element='sliding_image_lr']", {transformOrigin: "right bottom", rotation: -4})
    const slidelr_number = $("[data-element='sliding_image_lr'] picture").length;
    gsap.set("[data-element='sliding_image_lr']", {xPercent: -100,y: 0});
    
    

    // let homeslidingimages2 =  gsap.to("[data-element='sliding_image_lr']", {
    //   xPercent: 100, 
    //   y: - $qs("[data-element='sliding_image_lr']").offsetHeight * (slidelr_number - 2.1) + 32 * slidelr_number,
    //   duration: 10,
    //   ease: "none",
    //   scrollTrigger: {
    //     trigger: "[data-element='sliding_image_lr']",
    //     //pin: true,
    //     scrub: true,
    //     start: "top " + "+="+""+$(window).height() * 3 + "px",
    //     end:"+="+""+$(window).height() * 7 + "px"
    //     //pinSpacing:false
    //   }
    //   });
      
    
   
   //slider stats
    var swiper = new Swiper("[data-element='stats_home']", {
        modules: [Navigation, Pagination, Scrollbar],
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          click() {
            swiper.slideNext()
          },
        },
      });
    if($("[data-element='stats_home'] .swiper-slide").length == 1) {
        $("[data-element='stats_home']").addClass( "disabled" );
    }

    let sections = gsap.utils.toArray("[data-anim='fade']");
    sections.forEach((section) => {

      gsap.from(section,{
        scrollTrigger: {
          trigger: section,
          fastScrollEnd: true,
          once: true,
          start: "top bottom-=100px",
          end: "bottom 80%", 
        },
        duration: 1,
        ease: "power1.out",
        autoAlpha:0,
        y:"+=80px"
      });
      

    }); 
    gsap.set($("[data-anim='grid_gallery'] picture:nth-child(1)"), {y:"-=50px",x:"-=50px",});
    gsap.set($("[data-anim='grid_gallery'] picture:nth-child(2)"), {y:"-=50px",x:"+=50px",});
    gsap.set($("[data-anim='grid_gallery'] picture:nth-child(3)"), {y:"+=50px",x:"-=50px",});
    gsap.set($("[data-anim='grid_gallery'] picture:nth-child(4)"), {y:"+=50px",x:"+=50px",});
    gsap.to($("[data-anim='grid_gallery'] picture"),{
      scrollTrigger: {
        trigger: $("[data-anim='grid_gallery']"),
        fastScrollEnd: true,
        once:true,
        start: "top 80%",
        end: "50% 50%", 
      },
      duration: 1,
      ease: "power1.out",
      autoAlpha:1,
      y:"0",
      x:"0",
    });
    
   
}

export default homepage;